<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-spin" [fullScreen] = "true"><p style="color: white" ></p></ngx-spinner>


<ngx-ui-loader fgsColor="#edebff" fgsType="square-loader"></ngx-ui-loader>

<div class="top-loading-bar" *ngIf="barState$ | async as barState" [class.top-loading-bar--done]="barState === 'finishing'">
    <div class="top-loading-bar__bar"></div>
</div>
